export default "__VITE_ASSET__Dsr9msHq__"